import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Errore imprevisto" };
  }
  componentDidCatch(error, info) {
    console.error("NEXA ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[70vh] grid place-items-center px-4" data-testid="error-boundary">
          <div className="bg-card border border-border rounded-2xl p-8 text-center max-w-md w-full">
            <h1 className="font-heading text-2xl font-bold">Ops, qualcosa è andato storto</h1>
            <p className="text-muted-foreground mt-2 text-sm">Si è verificato un errore durante il caricamento di questa sezione.</p>
            <button
              data-testid="error-reload"
              onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
              className="mt-6 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground px-6 py-2.5 font-medium"
            >
              Torna alla home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
